<template>
  <v-card id="main_menu_card" :style="{ backgroundColor: backgroundColor }" flat class="border-0">
    <v-list nav dense class="mt-3 mb-3">
      <template v-for="(item, i) in menuItems">
        <v-row v-if="item.heading && !drawerIsMini" :key="i" align="center" class="pb-3">
          <v-col cols="6" v-if="item.heading" class="pb-1">
            <span class="text-caption grey--text ml-4">
              {{ item.heading }}
            </span>
          </v-col>
        </v-row>
        <v-list-item
          v-else-if="!item.heading"
          :key="i"
          :to="item.url"
          :id="item.id"
        >
          <v-list-item-action class="mr-2">
            <v-icon v-if="!drawerIsMini" size="16">
              {{ item.icon }}
            </v-icon>

            <v-tooltip v-else right>
              <template #activator="{ on }">
                <v-icon v-on="on">
                  {{ item.icon }}
                </v-icon>
              </template>
              <span>{{ item.text }}</span>
            </v-tooltip>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              <span class="subtitle-1">
                {{ item.text }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import PermissionsMixin from '@/mixins/permissions'

export default {
  mixins: [PermissionsMixin],
  data () {
    return {
      name: 'mainMenu'
    }
  },
  computed: {
    darkMode () {
      return this.$store.state.ui.darkModeEnabled
    },
    backgroundColor () {
      if (this.darkMode) {
        return this.$vuetify.breakpoint.smAndDown ? '#363636' : 'var(--v-application-base)'
      } else {
        return 'var(--v-application-base)'
      }
    },
    drawerIsMini: {
      get () {
        return this.$store.state.drawers.mainIsInMiniVariant
      },
      set () {
        this.$store.commit('drawers/toggleMiniVariantOnMain')
      }
    },
    menuItems () {
      const items = [
        // DASHBOARD
        {
          icon: 'dashboard',
          sufixIcon: 'fiber_new',
          text: this.$tc('dashboard', 2),
          acl: 'nop',
          url: { name: 'home' },
          id: 'home'
        },
        // PARTITION
        { heading: this.$tc('my_partition') },
        {
          icon: 'vpn_key',
          text: `${this.$tc('key', 2)}/${this.$tc('certificate', 2)}`,
          acl: 'nop',
          url: { name: 'partition-keys' },
          id: 'partition_keys'
        },
        // {
        //   icon: 'arrow_upward',
        //   text: this.$t('import'),
        //   acl: 'nop',
        //   url: { name: 'partition-import' },
        //   id: 'partition_import'
        // },
        {
          // icon: 'thumb_up_alt',
          // text: this.$tc('permission', 2),
          icon: 'thumbs_up_down',
          text: this.$tc('trust_relationship', 2),
          acl: 'nop',
          url: { name: 'partition-permissions' },
          id: 'partition_permissions'
        }
      ]

      // USERS
      if (this.canListUser || this.canUserAccessRemoteLog) {
        items.push({ heading: this.$tc('user', 2) })
        this.canListUser &&
          items.push({
            icon: 'group',
            text: this.$tc('partition', 2),
            acl: 'nop-4',
            url: { name: 'users-management' },
            id: 'users_management'
          })
        this.canUserAccessRemoteLog &&
          items.push({
            icon: 'security',
            text: this.$tc('password_policy'),
            acl: 'nop',
            url: { name: 'users-password-policy' },
            id: 'users_password_policy'
          })
      }

      // HSM
      if (
        this.canUserAccessRemoteLog ||
        this.canUserExtractBackup ||
        this.canUserUpdateFirmware
      ) {
        items.push({ heading: this.$tc('hsm') })
        this.canUserAccessRemoteLog &&
          items.push({
            icon: 'info',
            text: this.$tc('system_information', 2),
            url: { name: 'hsm-info' },
            acl: 'nop',
            id: 'system_information'
          })
        this.canUserAccessRemoteLog &&
          items.push({
            icon: 'format_align_left',
            text: this.$tc('log'),
            url: { name: 'hsm-log' },
            acl: 'nop',
            id: 'hsm_log'
          })
        this.canUserExtractBackup &&
          items.push({
            icon: 'history',
            text: this.$tc('backup'),
            url: { name: 'hsm-backup' },
            acl: 'nop',
            id: 'hsm_backup'
          })
        this.canUserAccessRemoteLog &&
          items.push({
            icon: 'dns',
            text: this.$tc('replication'),
            url: { name: 'hsm-replication' },
            acl: 'nop',
            id: 'hsm_replication'
          })
      }

      items.push({
        icon: 'handyman',
        text: this.$tc('tools'),
        url: { name: 'hsm-tools' },
        acl: 'nop',
        id: 'hsm_tools'
      })

      if (
        this.canUserAccessRemoteLog ||
        this.canUserExtractBackup ||
        this.canUserUpdateFirmware
      ) {
        items.push({
          icon: 'settings',
          text: this.$tc('settings'),
          url: { name: 'hsm-settings' },
          acl: 'nop',
          id: 'hsm_settings'
        })
      }

      return items
    }
  }
}
</script>
